import type { WithActiveBranchId } from '@app/api/shared';

export enum NotificationsEndpoints {
  GetNotifications = 'GetNotifications',
  GetUnreadCount = 'GetUnreadCount',
  MarkAsRead = 'MarkAsRead',
  MarkAllAsRead = 'MarkAllAsRead',
  GetNotificationSettings = 'GetNotificationSettings',
  UpdateNotificationSettings = 'UpdateNotificationSettings',
}

export interface ModelNotification {
  Id: number;
  EventType: string | null;
  EntityType: string | null;
  EntityId: number | null;
  PayloadJson: string | null;
  CreatedAt: string;
  IsRead: boolean;
  Title: string | null;
  Message: string | null;
}

export type GetNotificationsRequest = WithActiveBranchId<{
  page?: number;
  pageSize?: number;
  unreadOnly?: boolean;
}>;

export interface GetNotificationsResponse {
  Items: ModelNotification[] | null;
  Total: number;
  Page: number;
  PageSize: number;
}

export type GetUnreadCountRequest = WithActiveBranchId;

export type GetUnreadCountResponse = number;

export type MarkAsReadRequest = WithActiveBranchId<{
  id: number;
}>;

export type MarkAsReadResponse = void;

export type MarkAllAsReadRequest = WithActiveBranchId;

export type MarkAllAsReadResponse = void;

// Настройки уведомлений пользователя — матрица «событие × канал».
// Свагер: CRM.Dots.Notifications.ModelUserNotificationSettings.
// Одиночный свич «Отображение всплывающих уведомлений» в окне
// «Уведомления» — это агрегат по каналу in-app над Items (см.
// popupNotificationsSettings в NotificationsBell/lib).

// CRM.Dal.Enums.NotificationChannel. В свагере значения без названий (0/1);
// раскладка подтверждена вручную — уточнить у бэка, если поведение
// разойдётся. In-app — это как раз всплывающие тосты и колокольчик.
export enum NotificationChannel {
  InApp = 0,
  Email = 1,
}

export interface ModelNotificationSettingItem {
  EventType: string | null;
  // Tasks | OnlineRecords | Calls | Messages
  Category: string | null;
  Title: string | null;
  Channel: NotificationChannel;
  IsEnabled: boolean;
}

export interface ModelUserNotificationSettings {
  UserId?: number;
  Items: ModelNotificationSettingItem[] | null;
}

export type GetNotificationSettingsRequest = WithActiveBranchId;

export type GetNotificationSettingsResponse = ModelUserNotificationSettings;

export type UpdateNotificationSettingsRequest = WithActiveBranchId<{
  data: ModelUserNotificationSettings;
}>;

export type UpdateNotificationSettingsResponse = ModelUserNotificationSettings;
